import { PrimeReactPTOptions } from "primereact/api";
import { TreeTablePassThroughMethodOptions } from "primereact/treetable";
import { classNames } from "primereact/utils";
import { ColumnPassThroughMethodOptions } from "primereact/column";

import { datatable } from "./datatable";

export const treetable: PrimeReactPTOptions["treetable"] = {
  root: ({ props }: TreeTablePassThroughMethodOptions) => ({
    className: classNames("relative", {
      "flex flex-col h-full min-h-[1px]": props.scrollable && props.scrollHeight === "flex",
    }),
  }),
  loadingOverlay: {
    className: classNames(
      "fixed w-full h-full t-0 l-0 bg-gray-100/40",
      "transition duration-200",
      "absolute flex items-center justify-center z-2",
      "dark:bg-gray-950/40", // Dark Mode
    ),
  },
  loadingIcon: ["w-8 h-8"],
  header: {
    className: classNames(
      "bg-rdc-primary text-slate-700 border border-x-0 border-t-0 border-gray-300 p-4 font-bold",
      "dark:bg-gray-900 dark:text-white/70 dark:border-blue-900/40", // Dark Mode
    ),
  },
  scrollableWrapper: ({ props }: TreeTablePassThroughMethodOptions) => ({
    className: classNames({
      "relative overflow-auto": props.scrollable,
      "overflow-x-auto": props.resizableColumns,
    }),
  }),
  wrapper: datatable.wrapper,
  footer: {
    className: classNames(
      "bg-slate-50 text-slate-700 border border-x-0 border-t-0 border-gray-300 p-4 font-bold",
      "dark:bg-gray-900 dark:text-white/70 dark:border-blue-900/40", // Dark Mode
    ),
  },
  table: ["border-collapse table-fixed w-full"],
  thead: ({ props }: TreeTablePassThroughMethodOptions) => ({
    className: classNames("top-0 sticky z-[1]  bg-rdc-primaryLight", {
      "block sticky top-0 z-[1]": props.scrollable,
    }),
  }),
  tbody: ({ props }: TreeTablePassThroughMethodOptions) => ({
    className: classNames({
      block: props.scrollable,
    }),
  }),
  tfoot: ({ props }: TreeTablePassThroughMethodOptions) => ({
    className: classNames({
      block: props.scrollable,
    }),
  }),
  headerRow: ({ props }: TreeTablePassThroughMethodOptions) => ({
    className: classNames({
      "flex flex-nowrap w-full": props.scrollable,
    }),
  }),
  // @ts-expect-error Revisar en futuras versiones de Prime si se soluciona el type
  row: datatable.bodyRow,
  column: {
    headerCell: datatable.column?.headerCell,
    bodyCell: datatable.column?.bodyCell,
    rowToggler: {
      className: classNames(
        "relative inline-flex items-center justify-center align-center cursor-pointer select-none overflow-hidden bg-transparent",
        "w-8 h-8 border-0 rounded mr-0.5",
        "dark:text-white/70", //Dark Mode
      ),
    },
    sortIcon: datatable.column?.sortIcon,
    sortBadge: {
      className: classNames(
        "h-[1.143rem] min-w-[1.143rem] leading-[1.143rem] text-blue-700 bg-blue-50 ml-2 rounded-[50%]",
        "dark:text-white/80 dark:bg-blue-500/40", // Dark Mode
      ),
    },
    columnResizer: [
      "block absolute top-0 right-0 m-0 w-2 h-full p-0 cursor-col-resize border border-transparent",
    ],
  },
  checkbox: ({ context }: ColumnPassThroughMethodOptions) => ({
    className: classNames(
      "flex items-center justify-center",
      "border-2 w-6 h-6 text-gray-600 rounded-lg transition-colors duration-200",
      {
        "border-blue-500 bg-blue-500 dark:border-blue-400 dark:bg-blue-400": context.checked,
        "border-gray-300 bg-white dark:border-blue-900/40 dark:bg-gray-900": !context.checked,
      },
      {
        "hover:border-blue-500 dark:hover:border-blue-400 focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)]":
          !context.disabled,
      },
    ),
  }),
  checkboxicon: ({ context }: ColumnPassThroughMethodOptions) => ({
    className: classNames("w-4 h-4 transition-all duration-200 text-base dark:text-gray-900", {
      "text-white": context.checked,
    }),
  }),
  resizehelper: "absolute hidden w-px z-10 bg-blue-500 dark:bg-blue-300",
};
